export default {"src":"/_next/static/media/CVE.e42de6a6.svg","height":18,"width":18};